import PropTypes from 'prop-types';
import ErrorCard from 'commons/card/ErrorCard';
import LoadingCard from 'commons/card/LoadingCard';
import React from 'react';
import GestionGrid from '../tables/GestionGrid';
import { useGetUrlQuery } from '../../redux/api/cache';

export default function ParameterGestion(props) {
  const { data, isLoading, isError, isFetching } = useGetUrlQuery(props.path);

  return (
    <div style={{ margin: '15px 15px 0 15px' }}>

      {!isLoading && isError ? <ErrorCard title={props.title} /> : null}
      {(isLoading || isFetching) && !isError ? <LoadingCard title={"Chargement..."} /> : null}
      {!isLoading && !isFetching && !isError && data ? (
        <div>
          <div className="inline"
            style={{
              backgroundColor: 'white',
              border: '1px #f3f5f5 solid',
              borderBottom: '0px white solid',
              borderRadius: '1px',
              boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
              padding: '15px 30px 15px 30px',
              margin: '15px', marginBottom: '0'
            }}>
            <h1 style={{
              textTransform: 'uppercase',
              color: 'dimgrey',
              fontWeight: 'bold',
              fontSize: '22px'
            }}
              className="me-auto">
              {props.title}
            </h1>
          </div>
          <GestionGrid
            data={data}
            route={props.route}
            firstCol={props.firstCol}
            path={props.path}
            creation={props.creation}
            modification={props.modification}
            canAdd={props.canAdd}
            name={props.title}
            id={props.id} />
        </div>

      ) : null}
    </div>
  );
}

ParameterGestion.propTypes = {
  firstCol: PropTypes.any,
  path: PropTypes.string,
  route: PropTypes.any,
  title: PropTypes.string,
  creation: PropTypes.string,
  modification: PropTypes.string,
  canAdd: PropTypes.bool,
  id: PropTypes.string
};
